import { takeLatest, call, put, all } from "redux-saga/effects"
import axios from "axios"
import { push } from "connected-react-router"
import { values, flatMap } from "lodash"
import { GET_DIVISIONS_WATCHER, CREATE_COLLABORATOR_WATCHER, GET_GENDERS_WATCHER, GET_EMPLOYEES_WATCHER, GET_CATEGORIES_WATCHER, GET_LOCATIONS_WATCHER } from "./constants"
import {
  getDivisionsSuccess,
  getDivisionsFailed,
  createCollaboratorEnd,
  getGendersSuccess,
  getGendersFailed,
  getEmployeesSuccess,
  getEmployeesFailed,
  getCategoriesSuccess,
  getCategoriesFailed,
  getLocationsSuccess,
  getLocationsFailed
} from "./actions"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../utils/storage"

// Individual exports for testing

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

export function getDivisionsApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}v2/companies/${LOCAL_COMPANY_ID()}/division-names`,
  })
}

export function getLeadersApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/employees?source=select`,
  })
}

export function getCurrencyApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}currencies`,
  })
}

export function getCategoriesApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/positionlevels`,
  })
}

export function getGendersApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}genders/`,
  })
}

export function getLocationsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segment-variables/groups/7`,
  })
}

function createCollaboratorsApi(payload) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees`,
    data: payload,
  })
}

export function* createCollaboratorSaga(action) {
  try {
    const data = yield call(createCollaboratorsApi, action.payload)

    messageSuccess("Los cambios han sido guardados")
    yield put(createCollaboratorEnd())
    yield put(push("/organization#collaborators"))
  } catch (e) {
    yield put(createCollaboratorEnd())
    returnMessage(e)
  }
}

export function* getGendersSaga() {
  try {
    const [genders] = yield all([call(getGendersApi)])
    yield put(getGendersSuccess(genders.data.data))
  } catch {
    yield put(getGendersFailed())
    const {
      response: { data },
    } = JSON.parse(JSON.stringify(e))
    yield call(messageFailed, data.data.error)
  }
}


export function* getLocationsSaga() {
  try {
    const [locations] = yield all([call(getLocationsApi)])
    yield put(getLocationsSuccess(locations.data.data))
  } catch {
    yield put(getLocationsFailed())
    const {
      response: { data },
    } = JSON.parse(JSON.stringify(e))
    yield call(messageFailed, data.data.error)
  }
}


export function* getCategoriesSaga() {
  try {
    const [categories] = yield all([call(getCategoriesApi)])
    yield put(getCategoriesSuccess(categories.data.data))
  } catch {
    yield put(getCategoriesFailed())
    const {
      response: { data },
    } = JSON.parse(JSON.stringify(e))
    yield call(messageFailed, data.data.error)
  }
}

export function* getEmployeesSaga() {
  try {
    const [employees] = yield all([call(getLeadersApi)])
    yield put(getEmployeesSuccess(employees.data.data))
  } catch {
    yield put(getEmployeesFailed())
    const {
      response: { data },
    } = JSON.parse(JSON.stringify(e))
    yield call(messageFailed, data.data.error)
  }
}

export function* getDivisionsSaga() {
  try {
    const [
      divisions,
    ] = yield all([
      call(getDivisionsApi),
    ])

    const payload = {
      divisions: divisions.data.data,
    }

    yield put(getDivisionsSuccess(payload))
  } catch (e) {
    const {
      response: { data },
    } = JSON.parse(JSON.stringify(e))

    yield call(messageFailed, data.data.error)
  }
}

export default function* collaboratorsCreateSaga() {
  yield takeLatest(GET_DIVISIONS_WATCHER, getDivisionsSaga)
  yield takeLatest(GET_GENDERS_WATCHER, getGendersSaga)
  yield takeLatest(GET_EMPLOYEES_WATCHER, getEmployeesSaga)
  yield takeLatest(GET_CATEGORIES_WATCHER, getCategoriesSaga)
  yield takeLatest(GET_LOCATIONS_WATCHER, getLocationsSaga)
  yield takeLatest(CREATE_COLLABORATOR_WATCHER, createCollaboratorSaga)
}
